import React from 'react'
import { useHistory } from 'react-router-dom'
import $ from 'jquery'
import './clients.css'
import TablePaginated from '../features/clients/tablePaginated'
import HttpRequests from '../api/httpRequests'
import { useKeycloak } from '@react-keycloak/web'

export default function Client() {
  let history = useHistory()
  const { keycloak } = useKeycloak()

  const columns = React.useMemo(
    () => [
      {
        Header: 'Logo',
        accessor: 'logo'
      },
      {
        Header: 'Nome',
        accessor: 'name'
      },
      {
        Header: '',
        accessor: 'uuid'
      }
    ],
    []
  )
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const fetchIdRef = React.useRef(0)

  const fetchData = React.useCallback(async ({ pageSize, pageIndex }) => {
    const fetchId = ++fetchIdRef.current
    setLoading(true)

    try {
      const response = await HttpRequests.listClients({
        per_page: pageSize,
        page: pageIndex + 1
      })

      if (fetchId === fetchIdRef.current) {
        setData(response.data.data)
        setLoading(false)
      }

      document.title = 'Clientes - Admin Rocketquiz'
    } catch (error) {
      switch (error.response.status) {
        case 401:
          keycloak.logout()
          break

        case 403:
          history.push('/error/403')
          break

        case 404:
          history.push('/error/404')
          break

        default:
          history.push('/error/500')
      }
    } finally {
      $('.preloader').delay('250').fadeOut(500)
    }
  }, [])
  return (
    <TablePaginated
      columns={columns}
      data={data}
      fetchData={fetchData}
      loading={loading}
    />
  )
}
